<template>
  <form class="space-y-4" @submit.prevent="onSubmit">
    <div class="w-full">
      <UiInput
        v-model="signInForm.email"
        class="flex-1"
        name="email"
        :placeholder="$t('enterYourEmail')"
        color="white"
      />
    </div>
    <UiButton
      :loading="isSubmitting"
      type="submit"
      color="white"
      class="w-full"
    >
      {{ $t("resetPassword") }}
    </UiButton>
    <div class="ui-text-xs text-white text-center">
      {{ $t("backTo") }}
      <NuxtLink
        class="ui-text-xs text-white underline underline-offset-2 hover:no-underline"
        :to="localePath('/sign-in')"
      >
        {{ $t("signIn") }}
      </NuxtLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate";
import { object, string } from "yup";
import { ForgotForm } from "ecom-types";
import { FetchError } from "ofetch";
const { t } = useI18n();

const { openSystemDialog } = useSystemDialogs();
const { onResetPassword } = useAuth();
const localePath = useLocalePathPolyfill();

const initialSignInForm: ForgotForm = {
  email: "",
};

const schema = object().shape({
  email: string().email().required().label(t("email2")),
});

const signInForm = reactive(
  JSON.parse(JSON.stringify(initialSignInForm)),
) as ForgotForm;

const {
  handleSubmit: handleSubmitSignIn,
  resetForm: resetFormSignIn,
  setErrors: setErrorsSignIn,
  isSubmitting,
} = useForm({
  initialValues: initialSignInForm,
  validationSchema: schema,
});

const onSubmit = handleSubmitSignIn(async (values) => {
  try {
    await onResetPassword(values);
    signInForm.email = "";
    resetFormSignIn();
    openSystemDialog({
      type: "alert",
      title: `${t("success")}!`,
      text: `${t("recoverPasswordMessage")}.`,
    });
  } catch (error) {
    if (error instanceof FetchError) {
      setErrorsSignIn(responseErrorToObjectErrors(error?.data?.errors));
    }
  }
});
</script>
